export { default } from './InfoMaterialPopUp';



// WEBPACK FOOTER //
// ./src/components/InfoMaterials/InfoMaterialPopUp/index.js